export enum TransactionViewTrackingContext {
  AccountStatements = 'account_statements',
  BankAccount = 'bank_account',
  BankPayment = 'transaction_bank_payment',
  Bill = 'bill',
  /* Should never happen */
  BillEmber = 'bill_ember',
  ContactBalancePayment = 'transaction_contact_balance_payment',
  CustomersBalance = 'customers_balance',
  Ember = 'ember',
  Invoice = 'invoice',
  InvoiceEmber = 'invoice_ember',
  InvoiceLateFee = 'transaction_invoice_late_fee',
  SuppliersBalance = 'suppliers_balance',
  Transactions = 'transactions',
  UrlParams = 'url_params',
  VatAuditTrail = 'vat_audit_trail',
}
